export default {
  errors: {
    placeholder: 'Cannot render the player, check the placeholder Image',
  }
}
